<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link v-if="$store.getters.can('admin')" class="text-gray-400 hover:text-gray-600" href="/users">{{ $t('users.users') }}</Link>
        <span v-if="$store.getters.can('admin')" class="text-gray-400 font-medium">/ </span>
        {{ form.first_name }} {{ form.last_name }}
      </h1>
      <img v-if="user.photo" class="block ml-4 w-8 h-8 rounded-full" :src="user.photo" />
    </div>
    <trashed-message v-if="user.deleted_at && !viaProfile" class="mb-6" @restore="restore">
      {{ $t('users.trashed_message') }}
    </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2"
            :label="$t('users.first_name')"
            :required="true"
          />
          <text-input
            v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2"
            :label="$t('users.last_name')"
            :required="true"
          />
          <text-input
            v-model="form.email" type="email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2"
            :label="$t('users.email')"
            :required="true"
            :disabled="viaProfile"
          />

          <password-input  :label="$t('users.password')" v-model="form.password" :error="form.errors.password" autocomplete="new-password" class="w-full pb-8 pr-6 w-full lg:w-1/2"/>

          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <select-language v-model="form.language" :error="form.errors.language" :label="$t('users.language')" :required="true" />
            <p class="text-gray-400 text-xs pt-1">{{ $t('users.hints.language') }}</p>
          </div>
          <select-multiple
            v-if="!$store.getters.can('admin2') && !viaProfile"
            v-model="form.permissions" :default-options="roles.permissions"
            :error="form.errors.permissions"
            class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('users.permissions')"
          />
          <text-input
            v-if="!isVolunteer" v-model="form.authorization_date" type="date" :error="form.errors.authorization_date"
            class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('users.authorization_date')"
            :hint="$t('users.hint.authorization_date')"
          />
        </div>
        <div class="flex items-center justify-between px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button
            v-if="!user.deleted_at && !viaProfile" class="text-red-600 hover:underline" tabindex="-1" type="button"
            @click="destroy"
          >
            {{ $t('global.delete') }}
          </button>
          <div class="flex">
            <button
              v-if="!viaProfile && $store.getters.can('admin') && user.two_factor_enabled"
              class="btn-red"
              type="button"
              @click="resetMfa"
            >
              {{ $t('global.reset_mfa') }}
            </button>
            <Link
              v-if="viaProfile"
              class="btn-green"
              href="user/profile"
            >
              {{ $t('global.update_mfa') }}
            </Link>
            <loading-button :loading="form.processing" class="btn-indigo ml-1" type="submit">
              {{ $t('global.update') }}
            </loading-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import PasswordInput from '@/Shared/PasswordInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import SelectLanguage from '@/Shared/SelectLanguage'
import SelectMultiple from '@/Shared/SelectMultiple'
import Checkbox from '@/Shared/Checkbox'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    TrashedMessage,
    SelectLanguage,
    SelectMultiple,
    Checkbox,
    PasswordInput
  },
  layout: Layout,
  props: {
    user: Object,
    roles: Object,
    viaProfile: {
      type: Boolean,
      default: false,
    },
  },
  remember: 'form',
  data() {
    return {
      show:false,
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: '',
        owner: this.user.owner,
        language: this.user.language,
        permissions: this.user.permissions,
        authorization_date: this.user.authorization_date
      }),
    }
  },
  computed: {
    isVolunteer(){
      return !!(this.user.volunteer_id)
    },
  },
  methods: {
    update() {
      if (this.viaProfile) {
        // Beveiliging wanneer ze disabled zouden weghalen op het input field
        this.form.email = this.user.email
      }
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => {
          this.form.reset('password')
          this.$root.$i18n.locale = this.form.language
        },
      })
    },
    destroy() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.delete(`/users/${this.user.id}`)
        }
      })
    },
    resetMfa() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.put(`/users/${this.user.id}/reset-mfa`)
        }
      })
    },
    restore() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.put(`/users/${this.user.id}/restore`)
        }
      })
    },
  },
}
</script>
